import { apiClient } from "../../config";
import { env } from "../../../config/env";

import {
  GetArticleCategoriesResponse,
  GetArticleCategoryResponse,
  SuccessResponse,
} from "../../interface/articlescategories.interface";

class AdminArticleCategoriesService {

  /**
   * 📦 GET ALL
   */
  async getArticleCategories(): Promise<GetArticleCategoriesResponse> {
    const response = await apiClient.get<GetArticleCategoriesResponse>(
      env.ARTICLE_CATEGORIES.ADMIN.BASE
    );

    return response.data;
  }

  /**
   * 📄 GET ONE
   */
  async getArticleCategory(id: string): Promise<GetArticleCategoryResponse> {
    const response = await apiClient.get<GetArticleCategoryResponse>(
      `${env.ARTICLE_CATEGORIES.ADMIN.BASE}/${id}`
    );

    return response.data;
  }

  /**
   * ➕ CREATE
   */
  async createArticleCategory(payload: FormData): Promise<SuccessResponse> {
    const response = await apiClient.post(
      env.ARTICLE_CATEGORIES.ADMIN.BASE,
      payload
    );

    return response.data;
  }

  /**
   * ✏️ UPDATE
   */
  async updateArticleCategory(
    id: string,
    payload: any
  ): Promise<SuccessResponse> {
    const response = await apiClient.put(
      `${env.ARTICLE_CATEGORIES.ADMIN.BASE}/${id}`,
      payload
    );

    return response.data;
  }

  /**
   * 🖼️ UPDATE IMAGE
   */
  async uploadImageArticleCategory(
    id: string,
    payload: FormData
  ): Promise<SuccessResponse> {
    const response = await apiClient.post(
      env.ARTICLE_CATEGORIES.ADMIN.IMAGE(id),
      payload
    );

    return response.data;
  }

  /**
   * 🗑️ DELETE
   */
  async deleteArticleCategory(id: string): Promise<SuccessResponse> {
    const response = await apiClient.delete(
      `${env.ARTICLE_CATEGORIES.ADMIN.BASE}/${id}`
    );

    return response.data;
  }
}

export const adminArticleCategoriesService =
  new AdminArticleCategoriesService();